import * as Yup from 'yup';

/**
 * Validation schema for employee data
 */
export const employeeValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .required('First name is required')
    .min(1, 'First name must be at least 1 character')
    .max(50, 'First name must be less than 50 characters'),
    
  lastName: Yup.string()
    .trim()
    .required('Last name is required')
    .min(1, 'Last name must be at least 1 character')
    .max(50, 'Last name must be less than 50 characters'),
    
  email: Yup.string()
    .email('Invalid email format')
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value),
    
  phoneNumber: Yup.string()
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value)
    .matches(
      /^(\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$|^(\+\d{1,3}[-.\s]?)?\d{4,14}$/,
      'Invalid phone number format. US format: (555) 123-4567 or 555-123-4567. International: +1 555-123-4567 or +44 20 7123 4567'
    ),
    
  employmentType: Yup.string()
    .oneOf(['FULL_TIME', 'PART_TIME', 'CONTRACTOR', 'TEMPORARY', 'SEASONAL', ''], 'Invalid employment type')
    .nullable(),
    
  hireDate: Yup.date()
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value)
    .max(new Date(), 'Hire date cannot be in the future'),
    
  terminationDate: Yup.date()
    .nullable()
    .transform((value, originalValue) => originalValue === '' ? null : value)
    .when('hireDate', (hireDate, schema) => {
      if (hireDate) {
        return schema.min(hireDate, 'Termination date must be after hire date');
      }
      return schema;
    })
});

/**
 * Schema for creating a new employee (stricter requirements)
 */
export const createEmployeeSchema = employeeValidationSchema.shape({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
});

/**
 * Schema for updating an existing employee (more lenient)
 */
export const updateEmployeeSchema = employeeValidationSchema;